import React from 'react';
import { AboutContainer } from './ui';

export const AboutScreen: React.FC = () => (
  <>
    <AboutContainer />
  </>
);
